<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="rateTypes"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    /**
     * Allows the selection of a rate type ID by choosing its name or code from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-ratetypekey',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                rateTypes: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getRateTypes();
        },
        methods: {
            getRateTypes:function(){
                axios.get('/api/hotelsWithRateTypes')
                .then(function(response){
                    var rateTypes = [];
console.log("my response:", response);
                    response.data.forEach(function(hotel){
                        hotel.rate_types.forEach(function(rateType){
//console.log()
                            rateTypes.push({ text: '(' + hotel.hotel_code + ') ' + rateType.name, value: rateType.rate_type_key });
                        });
                    });
                    
                    this.rateTypes = rateTypes;
console.log("GOT EM", this.rateTypes, this.field.value);
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
